module.exports = __webpack_public_path__ + "assets/images/icons/icon_virus-green.svg?v=b2703dad";